'use strict'

define ['./notesModal.css'], () ->
  ($q, $scope, $rootScope, $uibModalInstance, Application, $cacheFactory) ->
    $scope.is_saving = false

    $scope.theme_color = $rootScope.THEME_COLOR

    $scope.update_notes = () ->
      $scope.is_saving = true
      Application.update(
          id: $scope.current_app.id,
          notes: $scope.current_app.notes
      ).$promise
        .then () ->
          $scope.is_saving = false
          $rootScope.$broadcast 'refresh-appbundle-table'
          $uibModalInstance.close()


// WEBPACK FOOTER //
// ./directives/appbundlesTable/notesModal/notesModal.coffee